import { useState } from "react";

const NotFound = () => {
    return ( 
        <div className="notfound" style={{margin:"250px auto"}}>
            <h1>Error 404</h1>
            <h2>The page you are looking for cannot be found</h2>
        </div>  
     );
}
 
export default NotFound;